import React from 'react';
import { formatPrice } from '../../utils/Formatting';
import { DISCOUNT_AMOUNT } from '../../constants/gameConfig';
import ReviewsDisplay from '../ReviewsDisplay';
import { ProductDetailsProps } from './types';

const ProductDetails: React.FC<ProductDetailsProps> = ({
  productData,
  currentProduct,
  getReviewsCount,
  getReviewsAverage,
  allPrizesCollected,
  labelPrice,
  labelDiscount,
  labelTotal,
  labelReviews,
  isDescriptionExpanded,
  labelShowMore,
  labelShowLess,
  onToggleDescription,
}) => {
  return (
    <>
      <div className="product-top-section">
        <div className="product-image-container">
          <img src={productData.image} alt={productData.title} className="product-image" />
        </div>
        <div className="product-header">
          <div className="product-header-title">
            <h1 className="product-title">{productData.title}</h1>
            <p className="product-price-row">
              <span className="product-price-value">{formatPrice(productData.price.toString(), 'EUR')}</span>
            </p>
          </div>
          <div className="product-header-price">
            <p className="product-price-row">
              <span className="discount-label">
                {labelDiscount}: -{formatPrice(DISCOUNT_AMOUNT.toString(), 'EUR')}
              </span>
              {!allPrizesCollected && ' 🔒'}
            </p>
            <p className="product-price-total">
              {labelPrice}: {formatPrice((Number(productData.price) - Number(DISCOUNT_AMOUNT)).toString(), 'EUR')}
            </p>
          </div>
          <div className="product-header-reviews">
            <div className="product-reviews">
              {getReviewsCount() > 0 && getReviewsAverage() > 0 && (
                <ReviewsDisplay average={getReviewsAverage()} count={getReviewsCount()} reviewsLabel={labelReviews} />
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="product-description">
        {productData.descriptionHtml && (
          <>
            <div
              className={`description-content ${isDescriptionExpanded ? 'expanded' : 'collapsed'}`}
              dangerouslySetInnerHTML={{ __html: productData.descriptionHtml }}
            />
            <button className="expand-button" onClick={onToggleDescription}>
              {isDescriptionExpanded ? labelShowLess : labelShowMore}
            </button>
          </>
        )}
      </div>
    </>
  );
};

export default ProductDetails;
